import { createContext, useContext, useState, useEffect } from "react";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  // Initialize from localStorage
  const [wishlistCount, setWishlistCount] = useState(() => {
    const savedCount = localStorage.getItem("wishlistCount");
    return savedCount ? parseInt(savedCount) : 0;
  });

  // Persist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("wishlistCount", wishlistCount);
  }, [wishlistCount]);

  const clearWishlist = () => {
    localStorage.removeItem("wishlistCount");
    setWishlistCount(0);
  };


  return (
    <WishlistContext.Provider value={{ wishlistCount, setWishlistCount , clearWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
